// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plain-dialog[data-v-7159b5a9]{overscroll-behavior-y:contain}.v-btn:not(.v-btn--round).v-size--default[data-v-7159b5a9]{padding:0 .25rem 0 0}.limited-dialog-height[data-v-7159b5a9]{overflow:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
